import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React, { useEffect, useState } from 'react';
import ShopsMap from '../ShopsMap';
import { address } from '@/commonTypes';
import mockData from '@/mock/address.json';
import Api from '@/api';
import getMoreList from '@/functions/getMoreList';
import Select from '@/components/common/Select';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';

export default function ProductsHero({ info }: { info?: any }) {
  const [position, setPosition] = useState([35.747288, 51.303524]); // default position
  const [count, setCount] = useState<string | number | undefined>(0);
  const { mockAddresses } = mockData;
  const [addresses, setAddresses] = useState<address[]>(mockAddresses);
  const { isLogin } = useLayoutContext();

  useEffect(() => {
    // getAddresses();
  }, []);

  const getAddresses = (start = 0) => {
    const params: any = { start: start, limit: 40 };

    Api.usersAddressList({ params })
      .then((res) => {
        getMoreList(start, res, addresses);

        setCount(res?.data?.response_details?.count);
      })
      .catch((err) => {
        console.error('getAddresses failed:', err);
      });
  };
  return (
    <>
      <Breadcrumb items={info?.breadcrumb?.items} />
      <SectionHead
        title={info?.hero?.title}
        text={
          <>
            {/* <span> */}
            {info?.hero?.text}
            {/* </span> */}
            {isLogin && (
              <Select
                list={addresses}
                fillFormFunction={(id) => {
                  // setFormData({ ...formData, cityId: id });
                  // handleFormDataChange("cityId", id)
                  let pos = addresses?.filter((x: { id?: string | number }) => x.id == id)?.[0];
                  setPosition([Number(pos.latitude), Number(pos.longitude)]);
                }}
                value={`${addresses?.filter((x: { longitude?: string | number; latitude?: string | number }) => x.latitude == position?.[0] && x?.longitude == position?.[1])?.[0]?.id}`}
                placeholder={' انتخاب آدرس شما '}
                buttonContainerStyle={` ${styles.select}`}
                id="addresses"
                className={`${styles.wrapper}`}
                extraButtonStyle={`${styles.extraButtonStyle}`}
              />
            )}
          </>
        }
        headingTag="h1"
        type="otherPages"
        textTitle={`${styles.selectSection}`}
        wrapper={`${styles.headWrapper}`}
        // titleClass={`${styles.titleClass}`}
      />
      <ShopsMap
        position={position}
        setPosition={setPosition}
        addresses={addresses}
        setAddresses={setAddresses}
      />
    </>
  );
}
